import { render } from "./hotHeader.vue?vue&type=template&id=2068bdc8&scoped=true"
import script from "./hotHeader.vue?vue&type=script&lang=js"
export * from "./hotHeader.vue?vue&type=script&lang=js"

import "./hotHeader.vue?vue&type=style&index=0&id=2068bdc8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2068bdc8"

export default script